import TaxonomyItem from "features/taxonomy/components/TaxonomyItem";
import { useSelector } from "react-redux";
import { Flex } from "shared/ui-basics/index";
import { getTaxonomyColorData } from "utils/helpers";

const Tag = ({ tagId = undefined, tag, action = undefined, mode = "", disabled = false, className = "" }) => {
	const currentTag = useSelector((state) => state.libraries.tags)?.find((tag) => tag?.id === tagId) || tag;
	const isUnlinkable = mode === "unlinkable";
	if (!currentTag) return <></>;

	const { color, backgroundColor } = getTaxonomyColorData({ entity: "tag", colorCode: currentTag?.colorCode });
	const handleClick = (e) => {

		if (action && isUnlinkable) {
			action(currentTag.id);
		}
	};
	return (
		<Flex
			align="center"
			className={"c-pointer " + className}
			key={currentTag?.id} id={currentTag?.id}
			className={className}
			onClick={handleClick}
		>
			<TaxonomyItem text={currentTag?.name} backgroundColor={backgroundColor} color={color} isUnlinkable={isUnlinkable} />
		</Flex>
	);
};

export default Tag;
